module.exports = __webpack_public_path__ + "img/Standard.e056ccb4.png";